module.exports = __webpack_public_path__ + "static/media/sound4.b2c95b4.ogg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/sound4.ogg
// module id = odiC
// module chunks = 3